export const LogoMark = ({ className = "w-9 h-9" }) => (
  <img src="/img/logo.png" alt="A.R.R.O.W ram skull and arrows logo" className={`${className} object-contain`} />
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="font-display font-extrabold text-xl tracking-[0.08em] leading-none text-left">
      A.R.R.O.W
      <span className="block font-mono text-[10px] font-normal tracking-[0.3em] text-[var(--muted)] mt-0.5">
        DEVELOPMENT GROUP
      </span>
    </span>
  </span>
);
